import { jsxs as b, jsx as l, Fragment as x } from "react/jsx-runtime";
import { forwardRef as h, useState as N, useMemo as w, cloneElement as g, useCallback as y, Children as z } from "react";
import { c as v } from "./tw-cn-mXgPecoF.mjs";
const c = {
  unselected: "size-22",
  touchdown: "size-18",
  // 18x18
  touchup: "size-26"
  // 26x26
}, S = h((m, p) => {
  const { icon: o, activeIcon: a, title: r = "", link: u = "", isActive: s = !1, badge: d, ...e } = m, [t, n] = N(c.unselected), f = w(() => {
    const i = s && a || o;
    return i ? g(i, {
      ...i.props,
      className: v(`${i.props.className} transition-all duration-100 ${t} `, o == null ? void 0 : o.props.className)
    }) : null;
  }, [o, a, t, s]);
  return /* @__PURE__ */ b(
    "a",
    {
      className: "relative flex h-56 items-center justify-center pb-4",
      href: u || void 0,
      onPointerDown: () => {
        n(c.touchdown);
      },
      onPointerUp: () => {
        n(c.touchup), setTimeout(() => {
          n(c.unselected);
        }, 100);
      },
      ref: p,
      role: "button",
      title: r,
      ...e,
      children: [
        /* @__PURE__ */ b("div", { className: "flex size-40 flex-col items-center overflow-hidden rounded-12 active:bg-opacity-black-5", children: [
          /* @__PURE__ */ l("div", { className: "m-auto flex size-26 max-h-26 min-h-26 items-center justify-center pb-2", children: f }),
          /* @__PURE__ */ l(
            "span",
            {
              className: v(
                `text-nowrap typography-label-10-regular-fixed ${a && s ? "!font-bold" : "font-normal"}`
              ),
              children: r
            }
          )
        ] }),
        d
      ]
    }
  );
});
S.displayName = "NDS.TabButton";
const I = h((m, p) => {
  const { children: o, onChange: a } = m, [r, u] = N(-1), s = y(() => {
    navigator.vibrate && navigator.vibrate(200);
  }, []), d = (e, t) => (n) => {
    s(), t == null || t(n), a == null || a(n, e), setTimeout(() => {
      u((f) => f === e ? -1 : e);
    }, 100);
  };
  return /* @__PURE__ */ b(x, { children: [
    /* @__PURE__ */ l("div", { className: "flex h-1 border-t border-t-opacity-black-10" }),
    /* @__PURE__ */ l(
      "nav",
      {
        className: "mx-auto grid w-full max-w-legacy-pc-size grid-cols-[repeat(auto-fit,minmax(0,1fr))] justify-center gap-0 bg-static-white px-8 pb-[env(safe-area-inset-bottom)]",
        ref: p,
        children: z.map(
          o,
          (e, t) => e ? g(e, {
            ...e.props,
            onClick: d(t, e.props.onClick),
            isActive: e.props.isActive ? !0 : r === t
          }) : null
        )
      }
    )
  ] });
});
I.displayName = "NDS.BottomNavigation";
export {
  I as B,
  S as T
};
